<template>
  <section>
  	  <el-row class="statusRow">
      <el-col>
        <el-row :gutter="10">
          <el-select class="xs24" v-model="issued_app_id" filterable  clearable placeholder="请选择发行游戏名称">
	        	<el-option v-for="(item,i) in PlacementList" :key="item.issued_app_id" :label="item.name" :value="item.issued_app_id"></el-option>
		      </el-select>
		      <el-button size="medium" type="primary" @click="planConfig">同步线上配置</el-button>
        </el-row>
      </el-col>
    </el-row>
		<el-row class="statusRow">
			<el-button size="medium" type="primary" @click="addProduct">新增广告主游戏</el-button> 当前线上创意： {{online_ceative_num}} &nbsp;&nbsp;&nbsp;&nbsp; 当前线上产品数量： {{online_product_num}}
		</el-row>
		<el-row class="statusRow">
			<el-button size="medium" type="primary" @click="showList=1" >直跳</el-button>
			<el-button size="medium" type="primary" @click="showList=2" v-if="jumpList.length>0">二跳</el-button>
		</el-row>
    <el-row class="statusRow" v-if="showList==1">
      
      <el-button size="medium" type="success" @click="changeStatus(false,1)">启用</el-button>
      <el-button size="medium" type="danger" @click="changeStatus(false,0)">禁用</el-button>
<!--      <el-button size="medium" type="info" @click="changeStatus(false,-1)">删除</el-button>-->
			 <el-input
		        @clear="getList"
		        @keyup.enter.native="search"
		        ref="input"
		        class="search  xs24"
		        v-model="pdata.kw"
		        clearable
		        placeholder="请输入产品名称/创意名称"
		        :suffix-icon="pdata.kw.length>0?'':'el-icon-search'"
		      >
		    </el-input>
			<el-select v-model="pdata.source"  clearable  placeholder="请选择产品来源">
		    	<el-option key="1" label="互导" value="1"></el-option>
		    	<el-option key="2" label="卖量" value="2"></el-option>
		    	<el-option key="3" label="测量" value="3"></el-option>
		  </el-select>
		  
		  
    </el-row>
    



    <!--列表-->
    <el-table
      :data="plist"
      style="width: 100%;min-width:1200px"
      @selection-change="select"
      stripe
      row-key="id"
      v-if="showList==1"
      
      :row-class-name="tableRowClassName"
    >
      <el-table-column type="selection"></el-table-column>
      <el-table-column prop="id" label="ID" min-width="80px" align="center"></el-table-column>
      <el-table-column prop="name" label="产品名称" align="left" >
        <template slot-scope="scope">
          <el-button
            type="text"
            :title="scope.row.name"
            @click="editProduct(scope.row)"
          >{{scope.row.name}}</el-button>
        </template>
      </el-table-column>
       <el-table-column prop="icon" label="产品来源" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.source==1">互导</span>
          <span v-if="scope.row.source==2">卖量</span>
          <span v-if="scope.row.source==3">测量</span>
        </template>
      </el-table-column>
      
      <el-table-column prop="icon" label="创意类型" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.jump_type==1?'直跳':'二跳'}}</span>
        </template>
      </el-table-column>
      
       <el-table-column prop="icon" label="创意个数"  align="center">
        <template slot-scope="scope">
          <span>{{scope.row.creative_num.ok}}/{{scope.row.creative_num.count}}</span>
        </template>
      </el-table-column>
      
      <el-table-column prop="path" label="产品路径" width="250px" align="center">
      	 <template slot-scope="scope">
          <a style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" :title="scope.row.path">{{scope.row.path}}</a>
        </template>
      </el-table-column>
      <el-table-column prop="update_time" label="更新时间" width="220px" align="center"></el-table-column>
      
      <el-table-column prop="status" label="​产品状态"  align="center" sortable :sort-method="(a,b)=>{return (a._status-0)-(b._status-0)}" >
      	<template slot-scope="scope">
          <span v-if="scope.row._status==1">待启用</span>
          <span v-if="scope.row._status==2">待禁用</span>
          <span v-if="scope.row._status==3">正常</span>
          <span v-if="scope.row._status==4">禁用</span>
        </template>
      </el-table-column>
      
      <el-table-column prop="status" label="操作" width="250px" align="center">
      	<template slot-scope="scope">
		      	<el-button
		            size="mini"
		            :type="scope.row.status=='1'?'success':'danger'"
		            @click="editStatus(scope.row)"
		          >{{scope.row.status=='1'?'正常':'禁用'}}</el-button>
		       <el-button type="text"  @click="$router.push({name:'创意投放日志',params:{index_id:scope.row.id},query:{type:'creative'}})">更新日志</el-button>   
        </template>
      	
      </el-table-column>
    </el-table>
    
  <div  v-if="showList==2"  class="el-table el-table--fit el-table--striped el-table--border el-table--group el-table--enable-row-hover el-table--enable-row-transition" style="width: 100%; min-width: 1200px;">
		<div class="el-table__body-wrapper">
			<table cellspacing="0" cellpadding="0" border="0" class="el-table__header" style="width: 100%">
				<colgroup>
					<col name="el-table_2_column_11" width="5%">
					<col name="el-table_2_column_13" width="10%">
					<col name="el-table_2_column_14" width="10%">
					<col name="el-table_2_column_15" width="10%">
					<col name="el-table_2_column_88" width="10%">
					<col name="el-table_2_column_89" width="20%">
					<col name="el-table_2_column_90" width="10%">
					<col name="el-table_2_column_91" width="15%">
					<col name="el-table_2_column_89" width="10%">
				</colgroup>
				<thead class="has-gutter">
					<tr class="">
						<th colspan="1" rowspan="1" class="el-table_2_column_11  is-center   is-leaf">
							<div class="cell">ID</div>
						</th>
						<th colspan="1" rowspan="1" class="el-table_2_column_12  is-center  ">
							<div class="cell">广告主游戏</div>
						</th>
						<th colspan="1" rowspan="1" class="el-table_2_column_13  is-center   is-leaf">
							<div class="cell">产品来源</div>
						</th>
						<th colspan="1" rowspan="1" class="el-table_2_column_14  is-center   is-leaf">
							<div class="cell">组合名称</div>
						</th>
						<th colspan="1" rowspan="1" class="el-table_2_column_15  is-center   is-leaf">
							<div class="cell">创意个数</div>
						</th>
						<th colspan="1" rowspan="1" class="el-table_2_column_88  is-center   is-leaf">
							<div class="cell">产品路径</div>
						</th>
						<th colspan="1" rowspan="1" class="el-table_2_column_89  is-center   is-leaf">
							<div class="cell">&#8203;产品状态</div>
						</th>
						<th colspan="1" rowspan="1" class="el-table_2_column_90  is-center   is-leaf">
							<div class="cell">更新时间</div>
						</th>
					
						<th colspan="1" rowspan="1" class="el-table_2_column_91  is-center   is-leaf">
							<div class="cell">操作</div>
						</th>
					</tr>
				</thead>
				<tbody v-for="item,index in jumpList" v-if="item.data&&item.data.length>0">
					<tr v-for="it,idx in item.data" class="el-table__row " :class="index%2==0?'el-table__row--striped':''" >
		    		<td class="is-center " :rowspan="item.data.length" v-if="idx==0">{{item.id}}</td>
		    		<td class="is-center " :title="it.name">{{it.name}}</td>
		    		<td class="is-center ">
		    			<span v-if="it.source==1">互导</span>
		          <span v-if="it.source==2">卖量</span>
		          <span v-if="it.source==3">测量</span>
		    		</td>
		    		<td class="is-center ">{{it.bale_name}}</td>
		    		<td class="is-center ">{{it.creative_num.ok}}/{{it.creative_num.count}}</td>
		    		<td class="is-center " :title="it.path">{{it.path}}</td>
		    		<td class="is-center ">{{it.status==1?'启用':'禁用'}}</td>
		    		<td  class="is-center ":rowspan="item.data.length" v-if="idx==0">{{item.update_time}}</td>
		    		<td class="is-center " :rowspan="item.data.length" v-if="idx==0">
		    			<el-button
		            size="mini"
		            :type="item.status=='1'?'success':'danger'"
		            @click="editStatus(item)"
		          >{{item.status=='1'?'正常':'禁用'}}</el-button>
		          <el-button type="text"  @click="$router.push({name:'创意投放日志',params:{index_id:item.id},query:{type:'creative'}})">更新日志</el-button> 
		    			 
		    		</td>
		    	</tr>
				</tbody>
				
				<tbody v-else>
						<tr >
		    		<td class="is-center " >{{item.id}}</td>
		    		<td class="is-center ">-</td>
		    		<td class="is-center ">
		    			-
		    		</td>
		    		<td class="is-center ">-</td>
		    		<td class="is-center ">-</td>
		    		<td class="is-center ">-</td>
		    		<td class="is-center ">-</td>
		    		<td class="is-center">{{item.update_time}}</td>
		    		<td class="is-center " >
		    			<el-button
		            size="mini"
		            :type="item.status=='1'?'success':'danger'"
		            @click="editStatus(item)"
		          >{{item.status=='1'?'正常':'禁用'}}</el-button>
		          <el-button type="text"  @click="$router.push({name:'创意投放日志',params:{index_id:item.id},query:{type:'creative'}})">更新日志</el-button> 
		    			 
		    		</td>
		    	</tr>
				</tbody>
				
			</table>
		</div>
	</div>
    

    
    
    
    <el-dialog
      :title="isAdd?'新增创意':'编辑创意'"
      :visible.sync="editDialog"
      width="950px"
      :close-on-click-modal="false"
    >
      <el-form :model="chooseProduct" :rules="rules" ref="ruleForm" :label-width="formLabelWidth">
      	<el-form-item label="跳转方式" prop="jump_type">
          <el-radio-group v-model="chooseProduct.jump_type" :disabled="isAdd?false:true">
            <el-radio label="1">直跳</el-radio>
            <el-radio label="2">二跳</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="chooseProduct.jump_type!=2">
	        <el-form-item label="产品选择" prop="product_base_id">
	            <el-select v-model="chooseProduct.product_base_id" filterable placeholder="请从产品管理里选择产品" :disabled="isAdd?false:true">
						    <el-option
						      v-for="item in productList"
						      :key="item.product_base_id"
						      :label="item.name"
						      :value="item.product_base_id"
						      default-first-option
						    ></el-option>
						  </el-select>
	        </el-form-item>
	        <el-form-item label="" prop="data"  class="myItems" style="margin-bottom: 0;"> 
	         	<el-row  :gutter="5" style="margin:0;">
	         			<el-col :span="3"  style="margin:0  0 10px 0;">序号</el-col>
	         			<el-col :span="5"  style="margin:0  0 10px 0;">创意名称</el-col>
	         			<el-col :span="4"  style="margin:0  0 10px 0;">创意权重</el-col>
	         			<el-col :span="3"  style="margin:0  0 10px 0;">创意帧数</el-col>
	         			<el-col :span="4"  style="margin:0  0 10px 0;">角标</el-col>
	         			<el-col :span="5"  style="margin:0  0 10px 0;">操作</el-col>
	         		</el-row>
	        </el-form-item>
	        <el-form-item label="" prop="data" v-for="(item,index) in chooseProduct.data" class="myItems">
	         		<el-row  :gutter="5" style="margin:0;">
	         			
		     			 	<el-col :span="3"  style="margin:0  0 10px 0;">
		     			 		<el-button
				            size="mini"
				            type="primary"
				            @click="addCreative(true,index)"
				          >新增</el-button>
		     			 		创意{{index+1}}:
		     			 	</el-col>
		     			 	<el-col :span="5"  style="margin:0  0 10px 0;">
		     			 		 <span v-if="!item.isAdd">{{item.rename}}</span>
		     			 		 <el-input v-if="item.isAdd"  v-model="item.rename" placeholder="请输入创意名称" class="input" clearable style="width:100%;"></el-input>
		     			 		
		     			 	</el-col>
		     			 	<el-col :span="4"  style="margin:0  0 10px 0;">
		     			 		<span v-if="!item.isAdd">{{item.weight}}</span>
		     			 		<el-input v-if="item.isAdd" v-model="item.weight" placeholder="请输入创意权重" class="input" clearable style="width:100%;"></el-input>
		     			 	</el-col>
		     			 	<el-col :span="3"  style="margin:0  0 10px 0;">
		     			 		<span v-if="!item.isAdd">{{item.frame}}</span>
		     			 		<el-input v-if="item.isAdd"  v-model="item.frame" placeholder="请输入创意帧数" class="input" clearable style="width:100%;"></el-input>
		     			 	</el-col>
		     			 	<el-col :span="4"  style="margin:0  0 10px 0;">
		     			 		 	<span v-if="!item.isAdd">
			     			 		 	<span v-if="item.heat==1">红点</span>
			     			 		 	<span v-if="item.heat==2">热门</span>
			     			 		 	<span v-if="item.heat==3">New</span>
			     			 		 	<span v-if="item.heat==4">感叹号</span>
		     			 		 	</span>
		     			 		 <el-select v-model="item.heat" filterable placeholder="请选择角标" v-if="item.isAdd">
		     			 		 	<el-option key="0" label="无" value="0"></el-option>
		     			 		 	<el-option key="1" label="红点" value="1"></el-option>
		     			 		 	<el-option key="2" label="热门" value="2"></el-option>
		     			 		 	<el-option key="3" label="New" value="3"></el-option>
		     			 		 	<el-option key="4" label="感叹号" value="4"></el-option>
								  </el-select>
		     			 	</el-col> 
		     			 	<el-col :span="5"  style="margin:0  0 10px 0;">
		     			 		<el-button
				            size="mini"
				            :type="item.status=='1'?'success':'danger'"
				            @click="changeCreative(index)" 
				          >{{item.status=='1'?'正常':'禁用'}}</el-button>
				          <el-button
				            size="mini"
				            type="primary"
				            @click="editCreative(index)"
				          >编辑</el-button>
				          <el-button
				            size="mini"
				            type="danger"
				            @click="deleteCreative(index)"
				            v-if="!item.creative_id&&index>0"
				          >删除</el-button>
		     			 	</el-col> 
	
	         		</el-row>
	         		<el-row  :gutter="10" style="margin:0;" v-if="item.isAdd">
	         			<el-col :span="3"  style="margin:0  0 10px 0;">&nbsp;</el-col> 	
	         			<el-col :span="4"  style="margin:0  0 10px 0;">
	         			 
					          <UploadImg :image="item.icon_url" v-on:update:image="imageUploadSuccess($event,index)" :url="url+'creative/icon'"></UploadImg>
					          <el-input :disabled="!item.isAdd" v-model="item.icon_name" placeholder="请输入图片名称" class="input" clearable style="width:100%;"></el-input>
					       
					       </el-col> 	
					      <el-col :span="4"  style="margin:0  0 10px 0;">
					      	  <img :src="item.icon_url_r" style="width: 148px"/>
					          <div>圆角图</div>
					       
					       </el-col> 	 
					      <el-col :span="13"  style="margin:0  0 10px 0;">
					       		<ul class="iconImgList" v-if="creativeIconList.length>0">
					       			<li v-for="(it,idx) in creativeIconList" @click="copyIconImage(it,index)">
					       				<img :src="it.url"/>
					       			</li>
					       			<li>推荐Icon</li>
					       		</ul>
	         			</el-col> 	
	         		</el-row>
	        </el-form-item>
	      </div>
	      <div v-if="chooseProduct.jump_type==2">
	      	<el-form-item label="请选择创意组合" prop="jump_type">
		      	<el-select class="xs24" v-model="chooseProduct.creative_bale_id" filterable  clearable placeholder="请选择创意组合名称">
		        	<el-option v-for="(item,i) in creativeGroupList" :key="item.creativebale_id" :label="item.name" :value="item.creativebale_id"></el-option>
			      </el-select>
		      </el-form-item>
	      </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
    
    <el-dialog title="更新日志" :visible.sync="logDialog">
      <el-table :data="plog">
        <el-table-column prop="username" label="操作人员" width="150"></el-table-column>
        <el-table-column prop="create_time" label="更新时间" width="200"></el-table-column>
        <el-table-column prop="content" label="备忘"></el-table-column>
      </el-table>
    </el-dialog>
  </section>
</template>

<script>
import { sclist, scstatus, saddc, seditc, getEditc,sclog ,newsplist,selectCreative,getPlacementList,baseUrl,getCreativeIcon,getCreativeGroup,pPlanConfig,changeSort} from "../../api/api";
import UploadImg from "./../uploadImg.vue";
import Test from "../../components/searchApp.vue";
import Sortable from "sortablejs";

export default {
  components: {
    UploadImg,
    Test
  },
  data() {
    return {
      rules: {
        icon: [
          { required: true, message: "请上传创意图片", trigger: "change" }
        ],
        frame: [{ required: true, message: "请输入图片帧数", trigger: "blur" }],
        type: [
          { required: true, message: "请选择创意类型", trigger: "change" }
        ],
        device: [
          { required: true, message: "请选择支持设备", trigger: "change" }
        ],
        heat: [
          { required: true, message: "请选择广告创意展示", trigger: "change" }
        ],
        product_id: [{ required: true, message: "请选择产品", trigger: "blur" }]
      },
      pdata: {
      
        type: "",
        status: "",
        kw: "",
        source:"",

      },
      issued_app_id:"",
      plist: [],
      jumpList:[],
      online_ceative_num:'',
      online_product_num:'',
      showList:1,
      maxPage: 1,
      config: [],
      jumpBox: false,
      cproduct: "",

      tags: [],
      chooseProduct: {
      	"creative_bale_id":"",
      	"issued_app_id":this.issued_app_id,
				"jump_type":"1",
				"product_base_id":"",
				data:[{
					"creative_type":"1",
					"rename":this.productName||"",
					"weight":"5",
					"frame":"",
					"heat":"",
					"icon_url":"",
					"icon":"",
					"icon_name":"",
					"status":1,
					"isAdd":true,
				}]
				},
      editDialog: false,
      formLabelWidth: "120px",
      log: "", //日志


      isAdd: false,
      cP: {
        index_id: "",
        status: "1",
        log: ""
      },
      selectProduct: [],
      logDialog:false,
      plog:[],
      productList:[],
      PlacementList:[],
      creativeGroupList:[],
      url:baseUrl,
      creativeIconList:[],
      productName:'',
    };
  },
  watch: {
   
    'pdata.source': {
      handler(n, o) {
       
        this.getList();
        
      },
      deep: true
    },
    'pdata.kw': {
      handler(n, o) {
       
        this.getList();
        
      },
      deep: true
    },
    'issued_app_id':{
    	 handler(n, o) {
        this.$router.push({name:'创意投放',params:{issued_app_id:this.issued_app_id}})
        this.getList();
      },
      deep: true
    },
    'chooseProduct.product_base_id':{
    	handler(n, o) {
        if(n!=o&&n){
          
          this.productList.forEach((v,i)=>{
        		if(v.product_base_id==this.chooseProduct.product_base_id){
        			this.productName=v.name;
        			if(this.chooseProduct.data[0].isAdd==true){
        				this.chooseProduct.data[0].rename=v.name;
        			}
        		}
        	})
        	this.getCreativeIconList();
        	
        }
       
      },
      deep: true
    	
    }
  },
  created() {
    let that = this;
//  document.onkeypress = function(e) {
//    var keycode = document.all ? event.keyCode : e.which;
//    if (keycode == 13 && that.editDialog) {
//      that.submit();
//      return false;
//    }
//  };
  },
  methods: {
  	  tableRowClassName({row, rowIndex}) {

        if (row._status==2||row._status==4) {
          return 'filtered';
        } else{
          return '';
        }
      },
  	 planConfig(){
  	 	//配置静态化
  	 	  this.$confirm('即将同步线上配置，是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
       }).then(() => {
       		pPlanConfig({issued_app_id:this.issued_app_id}, this.$cookie.getCookie("login")).then(res => {
		        if (res.code == 200) {
		          this.$message({ message: "同步成功", type: "success" });
		          this.getList();
		          
		        }
		        else{
		        	this.$message.error(res.msg);
		        }
		      });
       })
 
  	 },
  	 copyIconImage(e,index){
 
  	 			this.chooseProduct.data[index].icon_url=e.url;
		  	 	this.chooseProduct.data[index].icon_name=e.name;
		  	 	this.chooseProduct.data[index].icon_id=e.id;
		  	 	this.$forceUpdate();
  	 },
  	 imageUploadSuccess(e,index){
  
  	 	if(typeof(e)=='object'){
  	 			this.chooseProduct.data[index].icon_url=e.icon_url;
  	 			this.chooseProduct.data[index].icon_url_r = e.icon_url.replace(/\.jpg|\.png/g,'_r.png')
		  	 	this.chooseProduct.data[index].icon_name=e.icon_name;
		  	 	this.chooseProduct.data[index].icon_id=e.icon_id;
		  	 	this.$forceUpdate();
  	 	}
  	 	else if(e==''){
  	 		  this.chooseProduct.data[index].icon_url='';
  	 		  this.chooseProduct.data[index].icon_url_r='';
		  	 	this.chooseProduct.data[index].icon_name='';
		  	 	this.chooseProduct.data[index].icon_id='';
		  	 	this.$forceUpdate();
  	 	}
  	 
  	 	
  	 	
  	 },
  	 getNewAppList(){
  	 	  var p = "";
	      selectCreative("issued_app_id="+this.issued_app_id, this.$cookie.getCookie("login")).then(res => {
	        if (res.code == 200) {
	          this.productList = res.data;
	        }
	      });
  	 },
  	 openDealy(id) {
  	 	var p = 'type=creative&index_id='+id;
      sclog(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.logDialog = true;
          this.plog = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getList() {
      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      p=p+ "issued_app_id="+this.issued_app_id;
      sclist(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
        	if(res.data.list&&res.data.list.length>0){
        		 this.plist = res.data.list;
        	}
        	else{
        		this.plist =[]
        	}
        	if(res.data.jump&&res.data.jump.length>0){
        		  this.jumpList= res.data.jump;
        	}
        	else{
        		this.jumpList =[]
        	}
        	this.online_ceative_num = res.data.online_ceative_num;
        	this.online_product_num = res.data.online_product_num;
        }
      });
    },
    getConfig() {
      if (this.$store.config) {
        this.config = this.$store.config.ad_creative_type;
        this.tags = this.$store.config.product_tag;
      } else {
        setTimeout(() => {
          this.getConfig();
        }, 50);
      }
    },


    search() {
      // this.$refs.input.blur();
      this.getList();
    },
    addCreative(){
    	this.chooseProduct.data.push({
    		  "creative_type":"1",
					"rename":this.productName||"",
					"weight":"5",
					"frame":"",
					"heat":"",
					"icon":"",
					"icon_url":"",
					"icon_name":"",
					"status":1,
					"isAdd":true,
				})
    },
    editCreative(index){
    	this.chooseProduct.data[index].isAdd=true;
    	this.chooseProduct.data[index].icon_url_r = this.chooseProduct.data[index].icon_url.replace(/\.jpg|\.png/g,'_r.png')
    	
    	
    	this.$forceUpdate();
    },
    deleteCreative (index){
    	this.chooseProduct.data.splice(index,1)
    },
    editProduct(d) {
    	getEditc('index_id='+d.id, this.$cookie.getCookie("login")).then(res => {
	        if (res.code == 200) {
	          this.chooseProduct = res.data;
	          this.chooseProduct.index_id = this.chooseProduct.id;
	          delete this.chooseProduct.id;
	        }
	      });
      this.editDialog = true;
      this.isAdd = false;
    },
    changeCreative(index){

			this.chooseProduct.data[index].status = this.chooseProduct.data[index].status == 1 ? "0" : "1";

    },
    editStatus(s) {
      var p = {
        index_id: s.id,
        status: s.status == "1" ? "0" : "1",
        log: ""
      };
     this.$confirm(p.status==1?'即将启用'+s.name+' 是否继续?':'即将禁用'+s.name+'需二次确认, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
       }).then(() => {
        scstatus(p, this.$cookie.getCookie("login")).then(res => {
          if (res.code == 200) {
            this.getList();
          }
        });
      });
    },
     changeStatus(isSingle, s) {
      if (!isSingle && this.selectProduct.length == 0) {
        this.$message.error("请先选择需要批量操作的数据");
        return;
      }
      if (isSingle) {
        this.cP.index_id = s.id;
        this.cP.status = s.status == 1 ? "0" : "1";
      } else {
        this.cP.status = s;
      }

      if (this.cP.status == 0) {
        this.cP.log = "禁用产品";
      } else if (this.cP.status == 1) {
        this.cP.log = "启用产品";
      } else if (this.cP.status == -1) {
        this.cP.log = "删除产品";
      }
      this.$confirm(this.cP.status==1?'启用需二次确认, 是否继续?':'禁用需二次确认, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
	      scstatus(this.cP, this.$cookie.getCookie("login")).then(res => {
	        if (res.code == 200) {
	          this.getList();
	          this.$message({ message: this.cP.log + "成功", type: "success" });
	        }
	      });
      })
    },
  
    
    addProduct() {
  
    	this.creativeIconList = [];
      this.chooseProduct = {
      	"creative_bale_id":"",
      	"issued_app_id":this.issued_app_id,
				"jump_type":"1",
				"product_base_id":"",
				data:[{
					"creative_type":"1",
					"rename":this.productName||"",
					"weight":"5",
					"frame":"",
					"heat":"",
					"icon_url":"",
					"icon":"",
					"icon_name":"",
					"status":1,
					"isAdd":true,
				}]
        
      };
      this.editDialog = true;
      this.isAdd = true;
    },
    select(s) {
      this.selectProduct = s;
      var p = "测";
      s.forEach((v, i) => {
        p += "," + v.id;
      });
      this.cP.index_id = p.slice(2);
    },
    submit() {
    
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
        	if(this.chooseProduct.jump_type==1){
		          			for(var i=0;i<this.chooseProduct.data.length;i++){
							    		if(this.chooseProduct.data[i].rename==''||this.chooseProduct.data[i].weight==''||this.chooseProduct.data[i].icon_url==''){
							    			this.$message.error('添加创意不能有留空');
							    			return false;
							    			
							    		}
							    	}
		          			if(this.chooseProduct.product_base_id==''){
		          					this.$message.error('产品选择不能为空');
							    			return false;
		          			}
	          }
          	if (this.isAdd) {
	          
	          	
	            saddc(this.chooseProduct, this.$cookie.getCookie("login")).then(
	              res => {
	                if (res.code == 200) {
	                  this.$message({ message: "新增创意成功", type: "success" });
	                  this.getList();
	                  this.editDialog = false;
	                } else {
	                  this.$message.error(res.msg);
	                }
	              }
	            );       
          	} else {
	            // this.$prompt("请输入编辑原因", "提示", {
	            //   confirmButtonText: "确定",
	            //   cancelButtonText: "取消",
	            //   inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
	            //   inputErrorMessage: "内容不能为空"
	            // }).then(({ value }) => {
	            this.chooseProduct.log = "编辑内容";
	            seditc(this.chooseProduct, this.$cookie.getCookie("login")).then(
	              res => {
	                if (res.code == 200) {
	                  this.$message({ message: "编辑创意成功", type: "success" });
	                  this.getList();
	                  this.editDialog = false;
	                } else {
	                  this.$message.error(res.msg);
	                }
	              }
	            );
	            // });
          }
        } else {
          return false;
        }
      });
    },
    getPlacements(){
    	getPlacementList('', this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
        	if(res.data.list&&res.data.list.length>0){
        		this.PlacementList = res.data.list;
        	}
        	else{
        		this.PlacementList=[];
        	}
        	
      
          
          
        }
      });
    },
    getCreativeIconList(){
    	var p ='issued_app_id='+this.issued_app_id+'&product_base_id='+this.chooseProduct.product_base_id;
    	getCreativeIcon(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
        	if(res.data&&res.data.length>0){
        		this.creativeIconList = res.data;
        	}
        	else{
        		this.creativeIconList =[];
        	}
         
          
        }
      });
    },
    getBaleBox(){
    	getCreativeGroup('', this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
        	if(res.data&&res.data.length>0){
        		this.creativeGroupList = res.data;
        	}
        	else{
        		this.creativeGroupList = [];
        	}
        }
     });
    },
            	    //行拖拽
    rowDrop() {
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      const _this = this;
      Sortable.create(tbody, {
      	filter: '.filtered',
        onEnd({ newIndex, oldIndex }) {
          const currRow = _this.plist.splice(oldIndex, 1)[0];
          _this.plist.splice(newIndex, 0, currRow);
          var index_id = [];
          var sort = [];
          _this.plist.forEach((v, i) => {
            index_id.push(v.id);
            sort.push(i + 1);
          });
          var p = {
            index_id: index_id.join(","),
            sort: sort.join(",")
          };
          changeSort(p, _this.$cookie.getCookie("login")).then(res => {
            _this.getList();
          });
        }
      });
    },
  },
  mounted() {
  	this.issued_app_id = this.$route.params.issued_app_id;
  	
    this.getList();
    this.getConfig();
    this.getNewAppList();
    this.getPlacements();
    this.getBaleBox();
     this.rowDrop();
  }
};
</script>

<style scoped="scoped">
	ul.iconImgList { width: 100%; }
	ul.iconImgList li{
		list-style: none;
		float: left;
		width: 60px;
		height: 60px;
		margin:  5px;
		cursor: copy;
		line-height: 60px;
		text-align: center;
	}
		ul.iconImgList li img{
			width: 100%;
			height: 100%;
		}
		.el-table__row--striped td{
			background: #FAFAFA;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
</style>
<style>
.w260 {
  width: 260px;
}
.myItems .el-form-item__content{
	margin-left: 0 !important;
}

tr:nth-of-type(1) {
	border-top: 5px solid #A52A2A;
}
</style>



// WEBPACK FOOTER //
// Creative.vue?7103debc